import { fetchFromDashboardPublicApi } from 'commons/src/api/fetch';
import { CurrentDashboardResponse } from 'commons/src/models/commonTypeScript';
import { PublicDashboardProps } from '../models/commons';
import { addQueryParams } from './publicDevice';

export const fetchPublicDashboardInfo = async (payload: {
    dashboardUrl: string;
    measurementSystem?: string | undefined;
}): Promise<PublicDashboardProps> =>
    fetchFromDashboardPublicApi<PublicDashboardProps>(
        `/dashboard/${payload.dashboardUrl}${
            payload.measurementSystem ? addQueryParams(payload.measurementSystem) : ''
        }`,
        {
            method: 'GET',
        }
    );

export const fetchPublicDashboardTiles = async (payload: {
    dashboardUrl: string;
    measurementSystem?: string | undefined;
}): Promise<CurrentDashboardResponse> =>
    fetchFromDashboardPublicApi<CurrentDashboardResponse>(
        `/dashboard/${payload.dashboardUrl}/tiles${
            payload.measurementSystem ? addQueryParams(payload.measurementSystem) : ''
        }`,
        {
            method: 'GET',
        }
    );
